import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../Config";
import { makeStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";

import { IoMdHome } from "react-icons/io";
import { BiSolidCategory } from "react-icons/bi";
import { MdAccountCircle, MdMenuBook } from "react-icons/md";
import { FaUserLarge } from "react-icons/fa6";
import { FaHeadset, FaWallet } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";

import { useNavigate } from "react-router-dom";
import { CiUser } from "react-icons/ci";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: 70,
    position: "fixed",
    bottom: 0,
    left: 0,
    zIndex: 1500,
    boxShadow: "0 -2px 10px rgba(0,0,0,0.15)",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: 5,
  },

  actionItem: {
    "& .MuiBottomNavigationAction-label": {
      fontSize: "11px",
      marginTop: "3px",
      fontWeight: 600,
    },
    minWidth: "auto",
    padding: "0px 10px",
  },

  floatingCenter: {
    position: "absolute",
    top: -92,
    left: "50%",
    transform: "translateX(-50%)",
    background: "#fff3e6",
    width: 58,
    height: 58,
    borderRadius: "50%",
    boxShadow: "0px -2px 9px rgba(0,0,0,0.25)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#c95700",
    border: "3px solid white",
    zIndex: 2000,
  },

  floatingLabel: {
    position: "absolute",
    top: -26,
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "11px",
    fontWeight: 600,
    zIndex: 2000,
  }
}));

export default function SimpleBottomNavigation() {
  const classes = useStyles();
  const navigate = useNavigate();
  const userdata = localStorage.getItem("userData");

  const [value, setValue] = useState(0);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const isLoggedIn = userdata !== null && userdata !== "null";

  return (
    <div>
      {/* Floating Dashboard Button */}
      {/* {isLoggedIn && (
        <>
          <div
            className={classes.floatingCenter}
            onClick={() => handleNavigation("/student-admin")}
          >
            <MdDashboard size={28} />
          </div>

          <div className={classes.floatingLabel}>Dashboard</div>
        </>
      )} */}
      {isLoggedIn ? (
        <>
          <div
            className={classes.floatingCenter}
            onClick={() => handleNavigation("/student-admin")}
          >
            <MdDashboard size={28} />
          </div>
          <div className={classes.floatingLabel}>Dashboard</div>
        </>
      ) : (
        <>
          <div
            className={classes.floatingCenter}
            onClick={() => handleNavigation("/login")}
          >
            <CiUser  size={28} />
          </div>
          <div className={classes.floatingLabel}>My Account</div>
        </>
      )}


      <BottomNavigation
        value={value}
        onChange={(e, val) => setValue(val)}
        className={classes.root}
        showLabels
      >
        {/* MENU WHEN NOT LOGIN */}
        {!isLoggedIn ? (
          <>
            <BottomNavigationAction
              showLabel
              label="Home"
              icon={<IoMdHome size={24} />}
              className={classes.actionItem}
              onClick={() => handleNavigation("/")}
            />
            <BottomNavigationAction
              showLabel
              label="Services"
              icon={<BiSolidCategory size={24} />}
              className={classes.actionItem}
              onClick={() => handleNavigation("/service")}
            />
            {/* <BottomNavigationAction
              showLabel
              label="My Account"
              icon={<FaUserLarge size={22} />}
              className={classes.actionItem}
              onClick={() => handleNavigation("/log-in")}
            /> */}
            <div style={{ width: 70 }}></div>

            <BottomNavigationAction
              showLabel
              label="Examinations"
              icon={<MdMenuBook size={24} />}
              className={classes.actionItem}
              onClick={() => handleNavigation("/examinations")}
            />



            <BottomNavigationAction
              showLabel
              label="Help & Support"
              icon={<FaHeadset size={22} />}
              className={classes.actionItem}
              onClick={() => handleNavigation("/help-support")}
              style={{whiteSpace:"nowrap"}}
            />


          </>
        ) : (
          /* MENU AFTER LOGIN */
          <>
            <BottomNavigationAction
              showLabel
              label="Home"
              icon={<IoMdHome size={24} />}
              className={classes.actionItem}
              onClick={() => handleNavigation("/")}
            />

            <BottomNavigationAction
              showLabel
              label="Services"
              icon={<BiSolidCategory size={24} />}
              className={classes.actionItem}
              onClick={() => handleNavigation("/service")}
            />

            <div style={{ width: 70 }}></div>

            <BottomNavigationAction
              showLabel
              label="Examinations"
              icon={<MdMenuBook size={24} />}
              className={classes.actionItem}
              onClick={() => handleNavigation("/examinations")}
            />

            <BottomNavigationAction
              showLabel
              label="My Wallet"
              icon={<FaWallet size={24} />}
              className={classes.actionItem}
              onClick={() => handleNavigation("/wallet")}
            />
          </>
        )}
      </BottomNavigation>
    </div>
  );
}
